export const ERRORS = {
	SESSIONS_EXPIRED: 'SESSIONS_EXPIRED'
};

export const C = {
	NOTIFICATION_SPEED: 800
};
